<template>
  <div>
    <template v-if="heading">
      <div class="text-left comment-heading" :class="isRemoved ? 'comment-disabled' : ''">
        <strong v-if="model.last_year[field_name]">Last year comments</strong>
        <p v-html="model.last_year[field_name]"></p>

        <span class="glyphicon" :class="isRemoved ? 'glyphicon-plus' : 'glyphicon-remove'" @click="toggleRemoved"></span>&nbsp;
        <span class="glyphicon glyphicon-pencil" @click="setEditing" v-show="!isRemoved"></span>&nbsp;
        <strong>Comment:</strong>

        <span @click="setEditing" v-show="!editing">
          {{model.current[field_name] || '-'}}
        </span>
        <textarea type="text" v-model="model.current[field_name]" class='form-control' @blur="editing = false" v-show="editing" ref='textarea'>
        </textarea>
      </div>
    </template>
    <template v-else>
      <dl class="dl-horizontal" :class="isRemoved ? 'comment-disabled' : ''">
        <dt v-if="model.last_year[field_name]">Last year comments</dt>
        <dd v-html="model.last_year[field_name]"></dd>
      </dl>
      <dl class="dl-horizontal" :class="isRemoved ? 'comment-disabled' : ''">
        <dt class="text-left">
        <span class="glyphicon" :class="isRemoved ? 'glyphicon-plus' : 'glyphicon-remove'" @click="toggleRemoved"></span>&nbsp;
        <span class="glyphicon glyphicon-pencil" @click="setEditing" v-show="!isRemoved"></span>
        {{ title }} Comment
        </dt>
        <dd v-if="editing">
        <textarea type="text"
                  v-model="model.current[field_name]"
                  class='form-control'
                  @blur="editing = false"
                  ref='textarea'>
        </textarea>
        </dd>
        <dd v-else>
        <span @click="setEditing">
          {{model.current[field_name] || '-'}}
        </span>
        </dd>
      </dl>
    </template>
  </div>
</template>

<style type="text/css" media="screen">
.comment-heading {
  margin-bottom: 15px;
  margin-bottom: 15px;
}
.comment-disabled , .comment-disabled dt {
  text-decoration: line-through;
}
</style>

<script>
export default {
  props: ['field_name', 'model', 'title', 'heading'],
  data() {
    return {
      editing: false,
    }
  },
  created() {
    if (!(this.field_name in Object.keys(this.model.current)))
    {
      this.$set(this.model, this.field_name, '')
    }
  },
  computed: {
    isRemoved: function () {
      return Boolean((this.model.removedComments || {})[this.field_name])
    },
  },
  methods: {
    toggleRemoved: function () {
      if (this.model.removedComments == undefined)
      {
        this.$set(this.model, 'removedComments', {})
      }
      this.$set(this.model.removedComments, this.field_name, !this.isRemoved)
    },
    setEditing: function () {
      if (!this.isRemoved)
      {
        this.editing = true
        this.$nextTick(() => this.$refs.textarea.focus())
      }
    }
  }
}
</script>
<style>
span.glyphicon:hover {
  cursor: pointer
}
</style>
